module.exports = __webpack_public_path__ + "media/images/top/img_pickup_keyaki-b74436e9522d56d9b4d8f04ff6099315.webp";